export default "<app-header></app-header>\n    <app-groups *ngIf=\"gamesScores != ''\" gamesScores=\"{{gamesScores}}\"></app-groups>\n<app-footer></app-footer>"